
import { useNavigate } from "react-router-dom";
import List from 'src/components/grid.component';

import moment from 'moment/moment';

const badge = {
    "pending": "bg-pending",
    "rejected": "bg-red",
    "suspended": "bg-red",
    "cancelled": "bg-red",
    "submitted": "bg-consume",
    "approved": "bg-green"
  }
const RecentTransactions = ({ module }) => {
    const navigate = useNavigate()
    const navigateToTransactions = () => {
        navigate(`/transactions`);
    }
    const renderCustomCell = (transcationProps, column) => {
        const customCells = {
          "date": (transcation) => (<td><div className="gridLink text-light-valueColor">{transcation.dataItem.date ? <>{moment.utc(transcation.dataItem.date).local().format("DD/MM/YYYYhh:mm:ssA")}</> : transcation.dataItem.date}</div></td>),
          "status": (cellProps) => (
          <td> <span className={`status-badge ${badge[cellProps?.dataItem?.status?.toLowerCase()] || "bg-green"}`}>{cellProps?.dataItem?.status}</span></td>
        ),
        }
        if (customCells[column.field])
          return customCells[column.field](transcationProps);
      }
    return (
        <div className="kpi-section-style h-full">
            <div className="flex items-center justify-between">
                <h3 className='text-light-valueColor font-semibold text-lg dark:text-dark-valueColor'>Recent Transactions</h3>
                <button className="text-light-textBlue dark:text-dark-textBlue" onClick={() => navigateToTransactions()}>View All</button>
            </div>
            <List 
            url={process.env.REACT_APP_GRID_API + `DashBoard/RecentTransactions/${module}`}
            pSize={10}
            pageable= {false}
            filterOperators = {null}
            filter = {false}
            screenName={"Dashboard Transactions"}
            renderCustomCell={renderCustomCell}
            />
        </div>
    );
}

export default RecentTransactions;
